// Project Model
cv.ProjectNew = Backbone.RESTModel.extend({
  defaults: {
    stub: "",
    display_name: "",
    funds_needed: "",
    flex_metric_progress: "",
    flex_metric_goal: "",
    end_date: "",
    draft: "",
    appeal: "",

    share_auto: "",
    share_title: "",
    share_description: "",
    share_image: "",

    notif_donation: "",
    notif_team_join: "",
    notif_team_donation: "",

    custom_values: {},
    registration: {},

    active: "",
    project_updated: "",
    user_updated: "",
  },

  saveMap: {
    stub: "stub",
    display_name: "display_name",
    funds_needed: "funds_needed",
    flex_metric_progress: "flex_metric_progress",
    flex_metric_goal: "flex_metric_goal",
    end_date: "end_date",
    draft: "draft",
    appeal: "appeal",

    share_auto: "share_auto",
    share_title: "share_title",
    share_description: "share_description",
    share_image: "share_image",

    notif_donation: "notif_donation",
    notif_team_join: "notif_team_join",
    notif_team_donation: "notif_team_donation",

    custom_values: "custom_values",

    active: "active",
    project_updated: "project_updated",
    user_updated: "user_updated",
  },

  urlRoot: function () {
    return cv.new_api_path + "/projects";
  },

  initialize: function () {
    console.log("Project model initialized.");
  },
});
Cocktail.mixin(cv.ProjectNew, cv.mixins.SyncModel);

// Projects Collection
cv.ProjectsNew = Backbone.Collection.extend({
  url: function () {
    return cv.new_api_path + "/projects?" + $.param(this.params);
  },

  initialize: function (options) {
    console.log("Projects collection initialized.");
  },

  model: cv.ProjectNew,
});
Cocktail.mixin(cv.ProjectsNew, cv.mixins.PaginateModel);
